export const convert = (result, keyName = 'name', keyValue = 'id', keyChildren = 'children') => {
  let count = 1
  const _convert = (arr, currentItem) => {
    return arr?.map(item => {
      let parent = null
      item.label = item[keyName]
      item.value = item[keyValue]
      if (currentItem) {
        parent = { label: currentItem.name, value: currentItem.name, node: count }
        count += 1
        item.parent = parent
      }
      item.children = item[keyChildren]
      _convert(item.children, item)
      return item
    })
  }
  return _convert(result)
}
